import { connect } from 'react-redux'

import Footer from './footer'

import { toggleModal } from '../../reducers/modals'

export default connect((state) => state, { toggleModal })(Footer)
